export default __webpack_public_path__ + "static/media/1-008.1f004022.jpg";